/**
 * Header Scroll + Mobile Menu State
 *
 * At top              : announcement bar visible, header below it (transparent)
 * After bar scrolls away : header slides to top=0 (solid white)
 * Scroll back to top  : announcement bar reappears, header moves back down
 * Mobile menu open    : solid white bg, black text/icons  [.menu-is-open]
 */
(function () {
  var header = document.querySelector('header.header');
  if (!header) return;

  var announcementBar = document.querySelector('.announcement-bar-section');
  var barHeight = 0;

  // ── Measure announcement bar height ───────────────────────────────────────

  function updateBarHeight() {
    barHeight = announcementBar ? announcementBar.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-bar-height', barHeight + 'px');
    // Real header height (Dawn's --header-height measures an out-of-flow wrapper and reads 0px).
    // Used by sticky elements that must clear the header once it moves to top=0.
    document.documentElement.style.setProperty('--bp-header-height', header.offsetHeight + 'px');
  }

  updateBarHeight();
  window.addEventListener('resize', updateBarHeight, { passive: true });

  // ── Scroll ────────────────────────────────────────────────────────────────

  function onScroll() {
    var scrollY = window.scrollY;

    // Once user has scrolled past the announcement bar, move header to top=0
    if (scrollY >= barHeight) {
      header.style.top = '0px';
      header.classList.add('solid');
    } else {
      // Bar is (partially) visible — keep header below it
      header.style.top = (barHeight - scrollY) + 'px';
      header.classList.remove('solid');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ── Mega menu open/close → white header when at top ─────────────────────────

  function updateMegaMenuState() {
    var anyOpen = document.querySelector('.header__inline-menu details[open]');
    if (anyOpen) {
      header.classList.add('mega-menu-is-open');
    } else {
      header.classList.remove('mega-menu-is-open');
    }
  }

  var inlineMenu = document.querySelector('.header__inline-menu');
  if (inlineMenu) {
    inlineMenu.addEventListener('mouseenter', updateMegaMenuState);
    inlineMenu.addEventListener('mouseleave', updateMegaMenuState);
    // Also watch for details[open] attribute changes
    var megaObserver = new MutationObserver(updateMegaMenuState);
    inlineMenu.querySelectorAll('details').forEach(function (d) {
      megaObserver.observe(d, { attributes: true, attributeFilter: ['open'] });
    });
  }

  // ── Mobile menu open/close → white header ─────────────────────────────────

  var menuDetails = document.getElementById('Details-menu-drawer-container');
  if (!menuDetails) return;

  var observer = new MutationObserver(function () {
    if (menuDetails.hasAttribute('open')) {
      header.classList.add('menu-is-open');
    } else {
      header.classList.remove('menu-is-open');
    }
  });

  observer.observe(menuDetails, { attributes: true, attributeFilter: ['open'] });
})();
